import { render, staticRenderFns } from "./individualDetails.vue?vue&type=template&id=7b5308e1&"
import script from "./individualDetails.vue?vue&type=script&lang=js&"
export * from "./individualDetails.vue?vue&type=script&lang=js&"
import style0 from "./individualDetails.vue?vue&type=style&index=0&id=7b5308e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports